export const MUTATION_KEYS = {
  existingAdviserReferralMetadata: () => ['existing-adviser-referral-metadata'],
  newAdviserReferralMetadata: () => ['new-adviser-referral-metadata'],
  sessionMetadata: () => ['session-metadata'],
  validatePhoneNumber: () => ['validate-phone-number'],
}
